/**
 * Purpose: Shared image URL helpers for Points listing cards and detail gallery.
 */
import {
  getListingCoverImageUrl,
  withImagePlaceholder,
  IMAGE_PLACEHOLDER_PATH,
  imageFieldUrl,
} from '../../utils/imageFallback';

export { IMAGE_PLACEHOLDER_PATH };
export const POINT_IMAGE_PLACEHOLDER = IMAGE_PLACEHOLDER_PATH;

export function getPointCardImageUrl(entity) {
  if (!entity) return IMAGE_PLACEHOLDER_PATH;
  const listing = {
    display_image: entity.primary_image,
    images: Array.isArray(entity.images)
      ? entity.images
      : entity.primary_image
        ? [entity.primary_image]
        : [],
  };
  const fromGallery = getListingCoverImageUrl(listing);
  if (fromGallery !== IMAGE_PLACEHOLDER_PATH) return fromGallery;
  return withImagePlaceholder(
    imageFieldUrl(entity.primary_image_url) ||
      imageFieldUrl(entity.cover_image_url) ||
      entity.primary_image_url ||
      entity.cover_image_url,
  );
}

export function onPointImageError(e) {
  e.currentTarget.onerror = null;
  e.currentTarget.src = IMAGE_PLACEHOLDER_PATH;
}
